export class pageDto {
    pageSize: number;       // Número de elementos por página
    currentPage: number;    // Página actual
    pages: number;          // Número total de páginas
    records: number;        // Número total de elementos
    start: boolean = true;
    end: boolean = true;

    constructor(data: Partial<pageDto>) {
        this.pageSize = data.pageSize || 5;
        this.currentPage = data.currentPage || 1;
        this.pages = data.pages || 0;
        this.records = data.records || 0;
    }

    isStart(): boolean {
        return this.currentPage === 1;
    }

    isEnd(): boolean {
        return this.pages === 0 || this.currentPage === this.pages;
    }
}